import React, { useEffect, useState } from 'react';
import { inlineTooltipStyle } from './tooltipStyles';

// A small inline tooltip that appears next to an icon or button.
// - visible: controls whether the tooltip *should* be shown
// - delayMs: optional delay before showing (defaults to 0 for immediate)
// - children: tooltip content
// - style: optional extra styles to merge with inlineTooltipStyle
// - className: optional class for additional styling (e.g., fade-out animations)
export default function InlineTooltip({ visible, delayMs = 0, children, style, className }) {
  const [shouldShow, setShouldShow] = useState(false);

  useEffect(() => {
    let timer = null;

    if (visible) {
      if (delayMs > 0) {
        timer = setTimeout(() => {
          setShouldShow(true);
        }, delayMs);
      } else {
        setShouldShow(true);
      }
    } else {
      setShouldShow(false);
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [visible, delayMs]);

  if (!shouldShow) return null;

  return (
    <span style={{ ...inlineTooltipStyle, ...style }} className={className}>
      {children}
    </span>
  );
}
